import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';

export const editOrganizationFieldIssueViewExperience = new UFOExperience(
	'jsm-cs-organization-custom-field-issue-view-edit',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
